import { atom } from 'jotai'
import type { DataRange } from '@/src/services/token-info/asset-market-chart'

interface Interval {
  label: string
  value: DataRange
}

export const TIME_INTERVALS: Interval[] = [
  {
    label: '1D',
    value: '1',
  },
  {
    label: '1W',
    value: '7',
  },
  {
    label: '1M',
    value: '30',
  },
  {
    label: '1Y',
    value: '365',
  },
  {
    label: 'All',
    value: 'max',
  },
]

export const priceChartTimeIntervalAtom = atom(TIME_INTERVALS[0])
